<template>
  <div>
    <el-dialog
      class="basic_addType"
      :title="proParams.title"
      custom-class="addClass"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      v-dialogDrag
      :close-on-click-modal="false"
      @close="close_dialog"
      width="710px"
    >
      <div v-loading="loading">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="$store.state.app.web_language_wm == 'en' ? '' : '100px'" class="el-form-self-check">
          <el-form-item :label="$t('components_basic_addtype_index_2154')" prop="name" class="custom_form_item_by_static">
            <el-input v-model="ruleForm.name" size="large" :placeholder="$t('components_basic_addtype_index_2155')" :maxlength="60" show-word-limit></el-input>
          </el-form-item>
          <!--
          <el-form-item label="分类副标题：" prop="other_name">
            <el-input v-model="ruleForm.other_name" size="large" placeholder="请输入" :maxlength="60"></el-input>
          </el-form-item>
          -->
          <el-form-item :label="$t('components_basic_addarticle_message_2028')" prop="static" class="custom_form_item_by_static" v-if="proParams.objectType == 'product' || proParams.objectType == 'case' || proParams.objectType == 'news' || proParams.objectType == 'help'"
          >
            <el-input v-model="ruleForm.static" :placeholder="$store.state.app.static_placeholder" :maxlength="60" show-word-limit @blur="staticBlur"></el-input>
          </el-form-item>
          <staticTips :marginLeft="$store.state.app.web_language_wm == 'en' ? customFormItemByStaticWidth : 110" :marginTop="-14"  :typeName="'static'"></staticTips>

          <staticTips v-if="proParams.objectType == 'product' 
            || proParams.objectType == 'case' 
            || proParams.objectType == 'news'
            || proParams.objectType == 'help'" :marginLeft="$store.state.app.web_language_wm == 'en' ? 135 : 110" :marginTop="-14"></staticTips>
          <el-form-item :label="$t('components_basic_addtype_index_2156')" prop="type_name">
            <div class="fifter_tree">
              <div class="open_layer my_layer" v-show="!fifterTree" @click="showTree"></div>
              <div class="close_layer my_layer" v-show="fifterTree" @click="fifterTree = false"></div>
              <div class="fifter_down">
                <el-input v-model="ruleForm.type_name" clearable readonly :placeholder="$t('components_basic_addproduct_message_2101')">
                      <i v-show="!fifterTree" slot="suffix" class="el-input__icon el-icon-arrow-down" />
                      <i v-show="fifterTree" slot="suffix" class="el-input__icon el-icon-arrow-up" />
                </el-input>
              </div>
              <transition name="slide-fade">
                <el-scrollbar v-show="fifterTree" class="scroll_tree">
                  <div v-show="fifterTree" class="fifter_up org_tree org_tree_fifter">
                  <el-tree
                      ref="tree2"
                      :data="treeData"
                      :props="defaultProps"
                      :filter-node-method="filterNode"
                      :expand-on-click-node="false"
                      :default-expand-all="true"
                      class="filter-tree"
                      @node-click="choseOrg"
                    ></el-tree>
                  </div>
                </el-scrollbar>
              </transition>
            </div>
          </el-form-item>
          <el-form-item :label="articleTitle() + $t('components_basic_addarticle_message_2043')" class="custom_form_item_by_sort" prop="sort">
            <el-input v-model.number="ruleForm.sort" size="large" :placeholder="$t('components_basic_addtype_index_2157')" :maxlength="5" show-word-limit></el-input>
            <!-- <el-input-number v-model.number="ruleForm.sort" placeholder="请输入排序" controls-position="right" :min="0" :max="99999"></el-input-number> -->
          </el-form-item>
          <staticTips :marginLeft="$store.state.app.web_language_wm == 'en' ? customFormItemByOrderWidth : 110" :marginTop="-14" :typeName="'order'"></staticTips>
          
          <el-form-item
            v-show="proParams.objectType == 'product' || proParams.objectType == 'news'"
            :label="$t('components_basic_addtype_index_2158')"
            class="new_textarea"
            prop="content"
            :maxLength="1000"
            show-word-limit
          >
            <el-input
              v-if="false"
              v-model="ruleForm.content"
              size="large"
              maxlength="1000"
              rows="8"
              :placeholder="$t('components_basic_addtype_index_2159')"
              type="textarea"
              resize="none"
            ></el-input>
            <span v-if="false" class="num">{{ruleForm.content ? ruleForm.content.length : '0'}}/1000</span>

            <kind_editor :content.sync="ruleForm.content"  @on-content-change="onContentChange" width='550' height='260'></kind_editor>


          </el-form-item>
          <staticTips v-show="proParams.objectType == 'product' || proParams.objectType == 'news'" :marginLeft="$store.state.app.web_language_wm == 'en' ? 0 : 110" :marginTop="-14" :typeName="'cate.summary'"></staticTips>

          <el-form-item :label="$t('components_basic_addtype_index_2160')" style="margin-bottom: 10px !important;">
            <div v-for="(item, index) in imageUrl" :key="index" class="avatar-uploader-part imgPart">
              <a class="close-avatar-uploader el-icon-circle-close" @click="closeavatar(index)"></a>
              <img v-if="item" :src="item.path" class="avatar" />
            </div>
            <div class="avatar-uploader-part" v-if="imageUrl.length == 0" @click="showpop">
              <i class="el-icon-circle-plus avatar-uploader-icon"></i>
              <p>{{$t('components_basic_addproduct_message_2110')}}</p>
            </div>
          <staticTips :marginBottom="0" :marginTop="0" :typeName="'img'"></staticTips>
          </el-form-item>

          <el-form-item :label="$t('components_basic_addtype_index_2161')">
            <el-radio-group v-model="ruleForm.hide">
              <el-radio :label="'false'">{{$t('view_form_dialog_add_form_213')}}</el-radio>
              <el-radio :label="'true'">{{$t('view_back_top_index_105')}}</el-radio>
            </el-radio-group>
          <staticTips :marginBottom="0" :marginTop="0" :typeName="'showStatus'"></staticTips>
          </el-form-item>          
          
        <seo ref="infoSeo" :seoData="ruleForm" :seoType="'product_type'" :seoTitleType ="proParams.objectType == 'news' ? 'article_type' : proParams.objectType +'_type'"></seo>
        
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          type="primary"
          @click="confirmForm('ruleForm')"
          native-type="submit"
          :loading="isloading"
          :disabled="confirmDisabled"
        >{{$t('view_public_topbar_15')}}</el-button>
        <el-button size="small" @click="close_dialog" :disabled="isloading">{{$t('view_public_topbar_14')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '../../language/index'

// import { addOrEditProType, proTypeDetail } from '@/views/buildPlatform/api/index_ml'
import { staticRule, chineseRule } from "@/base/valid";
import { getStaticStr } from "@/base/base";
import seo from '../basic_common/seo.vue';
import { getStyle } from '@/utils/utils.js';
import {
  typedetail,
  typesave,
  detailtype,
  saveProType
} from '@/api/app.js'
export default {
  name: "addClass",
  props: {
    proParams: {
      type: Object,
      required: false,
      default: () => ({
        title: ''
      })
    },
    isShow: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  components: {
    seo,
  },
  watch: {
    isShow: function (val) {
      this.dialogVisible = val
      if (val) {
        if (this.proParams.type === 'edit') {
          if (this.proParams.id !== '0') {
            this.getProTypeDetail()
          } else {
            this.$message.error(i18n.t('components_basic_addtype_index_2162'))
          }
        }
      }
    },
    dialogVisible (val) {
      this.$emit('update:isShow', val)
    },
    ruleForm: {
      handler () {
        this.confirmDisabled = false
      },
      deep: true
    }
  },
  data () {
    let isNumber = (rule, value, callback) => {
      let patter = /^[0-9]*$/
      if (!patter.test(value)) {
        return callback(new Error(i18n.t('components_basic_addtype_index_2163')))
      } else {
        callback()
      }
    }
    return {
      filetype: 1, // 资源库选择的是图片 还是 视频
      change_name: '',// 资源库改变的是 imageUrl 还是 video_img，video_url
      imageUrl: [],
      dialogVisible: this.isShow,
      isloading: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      fifterTree: false,
      ruleForm: {
        id: '',
        name: '',
        other_name: "",
        pid: '0',
        hide: 'false',
        type_name: '',
        sort: 0,
        seo_title: '',
        seo_keywords: [],
        seo_description: '',
        seo: {
          title: '',
          keywords: '',
          description: '',

        },
        content: "", //分类内容
        static: "", // 静态文件资源
        img: []
      },
      loading: false,
      rules: {
        name: [ {
            required: true,
            message: i18n.t('components_basic_addtype_index_2155'),
            trigger: "blur"
          },
          {
            min: 1,
            max: 60,
            message: i18n.t('components_basic_addtype_index_2164'),
            trigger: "blur"
          },
          {
            pattern: /\S+/,
            message: i18n.t('components_basic_addarticle_message_2020')
          },
          {
            validator: chineseRule,
            trigger: "blur"
          }
        ],
        other_name: [],
        sort: [{
            type: 'number',
            max: 99999,
            min: 0,
            message: i18n.t('components_basic_addarticle_message_2021'),
            trigger: 'blur'
          }
        ],
        static: [
          {
            max: 60,
            message: i18n.t('components_basic_addtype_index_2165')
          },
          {
            validator: staticRule,
            trigger: "blur"
          }
        ],
        content:[
          {
            validator: chineseRule,
            trigger: "blur"
          }
        ]
      },
      confirmDisabled: true,
      customFormItemByStaticWidth: 0,
      customFormItemByOrderWidth: 0
    }
  },
  methods: {
    showpop() {
      const that = this;
      this.$store.commit('image_upload/set_fileType', this.filetype);
      this.$store.commit('image_upload/set_showTag', true);
      this.$store.commit('image_upload/set_fileLimit', 1);
      this.$store.state.image_upload.imgFile = e => {
        let pathList = e.map(e=>{
          e.img_path = e.filePath
          e.path = e.filePath
          return e
        })
        that.imageUrl = []
        that.imageUrl.push({
          path: pathList[0].filePath
        })
        that.$store.state.image_upload.imgFile = null;
      }
    },
    closeavatar(index) {
      this.imageUrl.splice(index, 1)
    },
    filterTreeData (id, treeData) {
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i].id === id) {
          return treeData[i].name
        }
        if (treeData[i].children) {
          const name = this.filterTreeData(id, treeData[i].children)
          if (name) {
            return name
          }
        }
      }
    },
    showTree () {
      this.fifterTree = true
      this.$refs.tree2.filter('false')
    },
    hiddenTree () {
      this.fifterTree = false
    },
    choseOrg (val) {
      this.ruleForm.type_name = val.name
      this.ruleForm.pid = val.id
      this.fifterTree = false
    },
    filterNode (value, data) {
      return true;
      if (!value) return true
      return data.level < 5
    },
    to_close () {
      // 清除表单校验的提示
      // 延时执行
      this.$nextTick(function () {
        if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].clearValidate();
        }
      })
      this.ruleForm = {
        id: '',
        name: '',
        other_name: '',
        pid: '0',
        hide: 'false',
        sort: '',
        seo_title: '',
        seo_keywords: [],
        seo_description: '',
        content: '', //分类内容
        typevalue: null,
        img: []

      }
      this.$emit('update:isShow', false);
    },
    articleTitle(){
      let title = '';
      if (this.proParams.objectType == 'case') {
        title = i18n.t('widgets_basic_article_classification_edit_334')
      } else if (this.proParams.objectType == 'news') {
        title = i18n.t('widgets_basic_article_classification_edit_333')
      } else if (this.proParams.objectType == 'video') {
        title = i18n.t('view_download_index_181')
      } else if (this.proParams.objectType == 'download') {
        title = i18n.t('router_index_69')
      } else if (this.proParams.objectType == 'help') {
        title = i18n.t('widgets_basic_article_classification_edit_335')
      } else if (this.proParams.objectType == 'product') {
        title = i18n.t('widgets_basic_classification_edit_482')
      } else if (this.proParams.objectType == 'atlas') {
        title = i18n.t('components_basic_addarticle_index_2010')
      }
      return title;
    },
    staticBlur() {
      this.ruleForm.static = getStaticStr(this.ruleForm.static);
    },
    confirmForm (formName) {
      if (this.ruleForm.seo_keywords) {
        this.ruleForm.seo_keywords.map(item=> {
          item.value = item.value.replace(/[\uff0c]/g, ",")
        })
        this.ruleForm.seo.keywords = this.ruleForm.seo_keywords;
      }
      if(this.ruleForm.seo_title) {
        this.ruleForm.seo.title = this.ruleForm.seo_title;
      }
      if(this.ruleForm.seo_description) {
        this.ruleForm.seo.description = this.ruleForm.seo_description;
      }
      this.isloading = true
      this.$refs[formName].validate(valid => {
        this.isloading = true
        // this.ruleForm.xcxId = this.proParams.xcxId
        // this.ruleForm.pid = this.proParams.pid
        let valid_seo = true;
          this.$refs.infoSeo.$refs.seo_data.validate(valid => {
          valid_seo = valid;
        });
        if (valid && valid_seo) {
          if (this.proParams.objectType == 'product' || this.proParams.objectType == 'case' || this.proParams.objectType == 'news' || this.proParams.objectType == 'help') {
            if (this.ruleForm.name && !this.ruleForm.static) {
              this.ruleForm.static = getStaticStr(this.ruleForm.name);
            }
            if (this.ruleForm.static) {
              this.ruleForm.static = getStaticStr(this.ruleForm.static);
            }
          }
          let type = this.proParams.type === 'edit' ? i18n.t('components_basic_addarticle_index_2003') : i18n.t('components_add_button_index_1953')
          // let title = this.proParams.objectType === 'case' ? '产品': this.addObjectType === 'case' ? '案例' : '新闻'
          let title = this.articleTitle();
          if (this.imageUrl.length !== 0) {
            this.ruleForm.img = this.imageUrl[0].path;
          }
          if (this.proParams.objectType === 'case' || this.proParams.objectType === 'news' || this.proParams.objectType ===
            'video' || this.proParams.objectType === 'download' || this.proParams.objectType === 'help' || this.proParams.objectType === 'atlas') {
            this.ruleForm.type = this.proParams.typevalue;
            if (this.proParams.type === 'edit') {
              this.ruleForm.id = this.proParams.id
            } else {
               delete this.ruleForm.id
            }
            let detail = {
            ...this.ruleForm,
            name_en: this.ruleForm.other_name
           };
            delete detail.other_name;
            this.loading = true
            typesave(detail).then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.isloading = false
                this.$message.success(type + title + i18n.t('components_basic_addtype_index_2166'))
                this.$emit('getNewTypeList');
                this.to_close()
              } else {
                this.$message.error(res.message)
              }
            }).catch((err) => {
              this.isloading = false
              this.$message.error(err.data.message);
              this.to_close()
              this.loading = false
            }).finally(() => {
              this.isloading = false
              this.to_close()
              this.loading = false
            })
          } else if (this.proParams.objectType == 'product') {
            this.ruleForm.type = this.proParams.typevalue;
            if (this.proParams.type === 'edit') {
              this.ruleForm.id = this.proParams.id
            } else {
              this.ruleForm.id = ''
            }
            this.loading = true
            saveProType(this.ruleForm).then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.isloading = false
                this.$message.success(type + title + i18n.t('components_basic_addtype_index_2166'))
                this.$emit('getNewTypeList');
                this.to_close()
              } else {
                this.$message.error(res.message)
              }
            }).catch((err) => {
              this.isloading = false
              this.$message.error(err.data.message);
              this.to_close()
              this.loading = false
            }).finally(() => {
              this.isloading = false
              this.to_close()
              this.loading = false
            })
          }
        } else {
          this.$nextTick(() => {
              let isError = document.getElementsByClassName("is-error");
              if (isError.length > 0) {
                isError[0].scrollIntoView({
                  // 滚动到指定节点
                  // 值有start,center,end，nearest，当前显示在视图区域中间
                  block: "center",
                  // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                  behavior: "smooth"
                });
                return false;
              }
          }); 
          this.isloading = false
        }
      })
    },
    getProTypeDetail () {
      // this.loading = true
      if (this.proParams.objectType === 'case' || this.proParams.objectType === 'news' || this.proParams.objectType ===
        'video' || this.proParams.objectType === 'download' || this.proParams.objectType === 'help' || this.proParams.objectType === 'atlas') {
        typedetail({
          id: this.proParams.id,
        }).then((res) => {
          this.loading = false
          if (res.code == 200 && res.data) {
            this.setInfo({ ...res.data, other_name: res.data.name_en })
          }
        }).catch((err) => {
          this.loading = false
        }).finally(() => {
          this.loading = false
        })
      } else if (this.proParams.objectType == 'product') {
        detailtype({
          id: this.proParams.id,
        }).then((res) => {
          this.loading = false
          if (res.code == 200 && res.data) {
            this.setInfo(res.data)
          }
        }).catch((err) => {
          this.loading = false
        }).finally(() => {
          this.loading = false
        })
      }
    },
    setInfo (proInfo) {
      this.imageUrl = [];
      if (proInfo.attr && proInfo.attr.img &&  typeof proInfo.attr.img == 'string') {
        const imgData = {
          path: proInfo.attr.img
        };
        this.imageUrl.push(imgData);
      }
      if (proInfo.img) {
        const imgData = {
          path: proInfo.img
        };
        this.imageUrl.push(imgData);
      }
      this.ruleForm.name = proInfo.name
      this.ruleForm.other_name = proInfo.other_name;
      this.ruleForm.hide = proInfo.hide
      this.ruleForm.sort = parseInt(proInfo.sort)
      this.ruleForm.content = proInfo.content
      this.ruleForm.static = proInfo.static;
      if (proInfo.pid === 0) {
        this.ruleForm.pid = 0
      } else {
        this.ruleForm.pid = proInfo.pid
        const typeName = this.filterTreeData(proInfo.pid, this.treeData)
        this.ruleForm.type_name = typeName
      }
      if (this.proParams.objectType === 'product') {
        this.ruleForm.seo_title = proInfo.attr.seo.title
        this.ruleForm.seo_keywords = proInfo.attr.seo.keywords
        this.ruleForm.seo_description = proInfo.attr.seo.description
      } else {
        this.ruleForm.seo_title = proInfo.seo_title
        this.ruleForm.seo_keywords = proInfo.seo_keywords
        this.ruleForm.seo_description = proInfo.seo_description
      }
      let seo_keywords = []
      if(this.ruleForm.seo_keywords.length !== 0 && this.ruleForm.seo_keywords.split(',').length > 0) {
        this.ruleForm.seo_keywords.split(',').map((item,index)=> {
          seo_keywords.push({
            value: item
          })
        })
      } else {
        seo_keywords = []        
      }
      this.ruleForm.seo_keywords = seo_keywords
    },
    close_dialog () {
      this.dialogVisible = true
      if (!this.confirmDisabled) {
        this.$confirm(i18n.t('view_dialog_index_170'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          // 不保存退出
          this.dialogVisible = false
        }).catch(() => {
          // 啥也不做
        })
      } else {
        // 保存
        this.dialogVisible = false
      }
    },
    onContentChange(content) {
      this.ruleForm.content = content;
    },

    onGetStyle(str, attr, data) {
      this.$nextTick(() => {
        const el = document.querySelector(str)
        console.log(el, 'el')
        if (el) {
          let value = getStyle(el, attr);
          console.log(value, 'value')
          this[data] = Number(value && value.replace(/px/, "")) || 0
        }
      })
    }
  },
  mounted() {    
    this.onGetStyle('.custom_form_item_by_static .el-form-item__content', 'marginLeft', 'customFormItemByStaticWidth');
    this.onGetStyle('.custom_form_item_by_sort .el-form-item__content', 'marginLeft', 'customFormItemByOrderWidth');
    if (this.isShow == true) {
      if (this.proParams.type === 'edit') {
        if (this.proParams.id !== '0') {
        let typeName = this.filterTreeData(this.ruleForm.pid, this.treeData)
        this.ruleForm.type_name = typeName
          this.getProTypeDetail()
        } else {
          this.$message.error(i18n.t('components_basic_addtype_index_2162'))
        }
      }
    }    
    if(this.proParams.type === 'add') { // 添加带有上级分类
      if (this.proParams.id !== '0'){
        this.ruleForm.pid = this.proParams.id
        let typeName = this.filterTreeData(this.proParams.id, this.treeData)
        this.ruleForm.type_name = typeName
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.basic_addType {
  /deep/ .el-dialog__body{
    max-height: calc(70vh - 116px);
    overflow: auto;
}
   /deep/ .el-dialog.addClass{
      margin-top:0 !important;
      top:50% !important;
      transform:translate(0,-50%);

    }
  /deep/ .el-dialog__footer {
    .dialog-footer {
      text-align: center;
      .el-button {
        margin: 8px 18px;
        padding: 0 28px;
        height: 34px;
      }
    }
  }
}
.addClass .new_textarea {
  position: relative;
}
.addClass .new_textarea .num {
  position: absolute;
  bottom: 3px;
  right: 10px;
  height: 20px;
  line-height: 20px;
  color: #a1a1a1;
  background-color: #fff;
}
.seotipswords{
  font-size: 12px;
  line-height: 20px;
  color: #333;
  opacity: 0.4;
}
.avatar-uploader-part {
  .imgPart {
    position: relative;
    display: flex;
    align-items: center;
    height: 84px;
    border: 1px solid transparent;
      img{
        display: inline-block;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    .deleteIcon{
      display: none;
      width: 14px;
      height: 14px;
      color: #fff;
      position: absolute;
      top: -7px;
      right: -7px;
      background-color: #ff5414;
      line-height: 14px;
      font-size: 12px;
      padding:0 1px ;
      border-radius: 999px;
    }
  }
}
.avatar-uploader-part:hover .deleteIcon {
  display: block;
}
.my_layer{
  width: 550px;
}
.scroll_tree{
  height: 150px;
  overflow-y: auto;
  position: absolute;
  overflow-x: hidden;
  left: 0;
  border: 1px solid #eee;
  width: 550px;
  background: #fff;
  z-index: 10;
  /deep/ .el-scrollbar__wrap{
    overflow-x: hidden;
    margin-right: 0 !important;
  }
}
.el-form-self-check {
  .el-form-item.is-error {
    margin-bottom:35px !important;
  }
  .el-form-item.zi_customer {
    margin-bottom:24px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic_addType/index.vue